require('../../modules/es6.array.fill');
module.exports = require('../../modules/_core').Array.fill;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/fn/array/fill.js
 ** module id = 80
 ** module chunks = 0 1
 **/